import { render } from "./artifacts.vue?vue&type=template&id=46ab6a24&lang=true"
import script from "./artifacts.vue?vue&type=script&lang=js"
export * from "./artifacts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chaoni/ZSpace/资料/jacknichao.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__